import React from 'react';

const Show = ({ test, children }) => {
  if (!test) return '';
  return <>{children}</>;
};

export default Show;
